import classNames from "./Search.module.css";
import { IoSearch } from "react-icons/io5";

interface SearchProps {
  query: string;
  setQuery: (value: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
}

const Search = ({
  query,
  setQuery,
  onKeyDown,
  placeholder,
  className,
}: SearchProps) => {
  return (
    <div className={`${classNames.Search} ${className || ""}`}>
      <IoSearch />
      <input
        type="text"
        placeholder={placeholder || "Search"}
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        onKeyDown={onKeyDown}
      />
    </div>
  );
};

export default Search;
